import {
  RESET_NEW_WEEKLY_UPDATE,
  FETCH_WEEKLY_UPDATES_START,
  FETCH_WEEKLY_UPDATES_SUCCESS,
  FETCH_WEEKLY_UPDATES_ERROR,
  FETCH_REMAINING_WEEKLY_UPDATES_START,
  FETCH_REMAINING_WEEKLY_UPDATES_SUCCESS,
  FETCH_REMAINING_WEEKLY_UPDATES_ERROR,
  POST_WEEKLY_UPDATE_START,
  POST_WEEKLY_UPDATE_SUCCESS,
  POST_WEEKLY_UPDATE_ERROR,
  DELETE_WEEKLY_UPDATE_START,
  DELETE_WEEKLY_UPDATE_SUCCESS,
  DELETE_WEEKLY_UPDATE_ERROR,
  UPDATE_WEEK_NUMBER,
  UPDATE_YEAR,
  UPDATE_ROLE,
  UPDATE_TEXT,
  UPDATE_TOTAL_COUNT,
  RESET_TOTAL_COUNT,
  INCREMENT_TOTAL_COUNT,
  DECREMENT_TOTAL_COUNT
} from './constants'

import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'

const getDefaultNewWeeklyUpdate = () => {
  return {
    week: 1,
    year: (new Date()).getFullYear(),
    role: '',
    text: ''
  }
}
const setLoadingTrue = () => true
const setLoadingFalse = () => false

const updateWeekNumber = (prev, { weekNumber }) => 
  ({ ...prev, week: weekNumber })

const updateYear = (prev, { year }) => 
  ({ ...prev, year: year })

const updateRole = (prev, { role }) => 
  ({ ...prev, role: role })

const updateText = (prev, { text }) => 
  ({ ...prev, text: text })

const updateTotalCount = (prev, { count }) => count

const incrementTotalCount = (prev) => prev + 1
const decrementTotalCount = (prev) => prev - 1

const resetTotalCount = () => 0

const loadingReducer = createReducer(setLoadingFalse(), {
  [FETCH_WEEKLY_UPDATES_START]: setLoadingTrue,
  [FETCH_WEEKLY_UPDATES_SUCCESS]: setLoadingFalse,
  [FETCH_WEEKLY_UPDATES_ERROR]: setLoadingFalse,
  [POST_WEEKLY_UPDATE_START]: setLoadingTrue,
  [POST_WEEKLY_UPDATE_SUCCESS]: setLoadingFalse,
  [POST_WEEKLY_UPDATE_ERROR]: setLoadingFalse,
  [DELETE_WEEKLY_UPDATE_START]: setLoadingTrue,
  [DELETE_WEEKLY_UPDATE_SUCCESS]: setLoadingFalse,
  [DELETE_WEEKLY_UPDATE_ERROR]: setLoadingFalse
})

const remainingLoadingReducer = createReducer(setLoadingFalse(), {
  [FETCH_REMAINING_WEEKLY_UPDATES_START]: setLoadingTrue,
  [FETCH_REMAINING_WEEKLY_UPDATES_SUCCESS]: setLoadingFalse,
  [FETCH_REMAINING_WEEKLY_UPDATES_ERROR]: setLoadingFalse,
})

const allFetchedReducer = createReducer(false, {
  [FETCH_REMAINING_WEEKLY_UPDATES_SUCCESS]: setLoadingTrue,
})

const totalCountReducer = createReducer(resetTotalCount(), {
  [UPDATE_TOTAL_COUNT]: updateTotalCount,
  [INCREMENT_TOTAL_COUNT]: incrementTotalCount,
  [DECREMENT_TOTAL_COUNT]: decrementTotalCount,
  [RESET_TOTAL_COUNT]: resetTotalCount
})

const newWeeklyUpdateReducer = createReducer(getDefaultNewWeeklyUpdate(), {
  [RESET_NEW_WEEKLY_UPDATE]: () => getDefaultNewWeeklyUpdate(),
  [UPDATE_WEEK_NUMBER]: updateWeekNumber,
  [UPDATE_YEAR]: updateYear,
  [UPDATE_ROLE]: updateRole,
  [UPDATE_TEXT]: updateText
})

export default combineReducers({
  newWeeklyUpdate: newWeeklyUpdateReducer,
  loading: loadingReducer,
  remainingLoading: remainingLoadingReducer,
  allFetched: allFetchedReducer,
  totalCount: totalCountReducer
})
